import React from 'react';
import "./App.css";
import RemoteCarousel from "./RemoteCarousel";
import StorySlide from "./StorySlide";
import InfiniteCarousel from "./InfiniteCarousel";

export default function App() {
const slides = [
  <StorySlide
    title={`Single Utility Voice AI`}
    desc="High‑accuracy voice AI for compliant, high‑volume tasks like password resets and routing."
    mainImg="/images/AI.png"
    backImg="/images/ai1.jpg"
  />,
  <StorySlide
    title={` CoPilot Plus`}
    desc="Deterministic, audit‑ready extensions for financial models, dashboards, and reporting."
    mainImg="/images/copilot.png"
    backImg="/images/ai6.jpg"
  />,
  <StorySlide
    title={`Agent Augment`}
    desc="Lightweight, on‑demand BPO tools for summaries, lookups, and fraud checks."
    mainImg="/images/agent.png"
    backImg="/images/ai2.jpg"
  />,
  <StorySlide
    title={`Precision AI`}
    desc="Deep‑analysis engine tools for reconciliation, anomaly flagging, and evidence trails."
    mainImg="/images/precision.png"
    backImg="/images/ai3.jpg"
  />,
];


   const remoteSlides = [
    {
      image: "/images/office1.jpg",
      title: "Voice Automation for Critical Self-Service",
      desc:
        "A major bank deployed a single-purpose voice/AI assistant used by over 90% of employees. IT service-desk call volume (password resets, device support) dropped by ~50%, freeing staff for higher-value tasks. The assistant has handled billions of interactions, reducing reliance on manual support.",
      link: "#",
    },
    {
      image: "/images/office2.jpg",
      title: "Deterministic Copilot for Financial Reporting",
      desc:
        "A global professional services firm streamlined finance operations using Power Platform applications and an AI-driven agent in Copilot Studio, integrated with SAP ERP. General ledger posting and payment clearing lead times dropped dramatically, saving significant staff effort and enabling focus on higher-value tasks.",
      link: "#",
    },
    {
      image: "/images/office5.jpg",
      title: "Real-Time Agent Assist for Call Centers",
      desc:
        "A major telecom deployed GenAI-enabled tools across its contact center. By analyzing incoming calls, the system predicts why customers are calling with ~80% accuracy and matches them to the best-suited agents. This improved call handling efficiency, reduced repetitive tasks, and allowed agents to focus on higher-value work.",
      link: "#",
    },
    {
      image: "/images/office6.jpg",
      title: "Traceable Document Reconciliation Engine",
      desc:
        "A Fortune 500 insurance company deployed an AI-based deepfake/synthetic-voice detection engine across its contact center. The system flagged ~97% of synthetic-voice calls, preventing unauthorized access and reducing fraud risk — strengthening the integrity of voice-channel authentication without requiring new infrastructure.",
      link: "#",
    },
  ];


  
  return (
    <div>
      <section className="luxGoldHero">
        <div className="luxGold-inner">
          <div className="logo">
            <img src="images/logo1.png"  alt="Company logo" ></img>
          </div>
          <div className='head-title'>
          <h1>Blue Enterprise Analytics</h1>
          </div>
          <h1>
            From Friction To Flow:
           <br />
            AI For Enterprise Efficiency.
          </h1>
        <button className="luxGold-btn">
          <a href="#contact">Contact Us</a>
          </button>
        </div>
      </section>

      {/* HERO IMAGE SECTION */}
      <section
        className="imgHero"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      >
        <div className="imgHero-overlay" />

        <div className="imgHero-content">

          <h1 className="imgHero-title">
          Stop High-Pressure Tasks from Dragging Down Your Team
          </h1>

          <p className="imgHero-desc">
           Blue Analytics builds single-focused automations that remove high-pressure bottlenecks inside enterprises. Our traditional programming and AI utility tools augment human expertise.
          </p>

          <div className="imgHero-line" />
        </div>
      </section>

      {/* SECTION 2 - splitGold as CAROUSEL */}
      <section className="splitGold splitGoldCarousel"  >    
          
            {/* SLIDE 1 */}
            <div className="sgSlide">
             <h2 className="splitGold-title">
                        The Bottlenecks Holding Enterprises Back
                      </h2>
              <div className="splitGold-wrap">
                <div className="splitGold-left">
                  <div className="splitGold-imgBox">
                    <img src="/images/remote.jpg" alt="Slide 1" />
                  </div>
                </div>
                <div className="splitGold-right">
                  <div className="splitGold-frame">
                    <div className="splitGold-frameInner">
                       <div className="pressure-wrap">
                        <div className="pressure-grid">
                          <div className="pressure-item">
                            <p><strong>High Volume : </strong>Automating password resets, access requests, and initial ticket routing.</p>
                            <p><strong>High Complexity : </strong>Fragmented tooling, inconsistent processes.</p>
                            <p><strong>High Criticality : </strong>Mistakes are costly, base integrity is non-negotiable.</p>
                            <p><strong>Time Pressure : </strong>Delayed reviews and approvals degrade CX.</p>
                          </div><br/>
                        </div>
                        <div className="pressure-footer">
                          These high-pressure tasks slow your teams, increase
                          errors, and drain resources. Precision automation
                          removes them instantly.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

      </section>
          {/* STATS SECTION */}
<section className="statsGold">
  <div className="statsGold-wrap">
    <h2 className="statsGold-title"> Automation in Action: Measurable Enterprise Value
</h2>

    <div className="statsGold-grid">
      <div className="statsGold-card">
        <div className="statsGold-number">$2.9 trillion</div>
        <div className="statsGold-label">Economic value that can be unlocked by automation by 2030
</div>
        <div className="statsGold-text">
          <a href="https://time.com/7341258/how-workers-will-adapt-in-ai-era/?utm_source=chatgpt.com" target="_blank" rel="noopener noreferrer" className="link-basic">Read the article</a>
        </div>
      </div>

      <div className="statsGold-card">
        <div className="statsGold-number">60 % </div>
        <div className="statsGold-label">Customers willing to use automation for service interactions.</div>
        <div className="statsGold-text">
          <a href="https://www.gartner.com/en/newsroom/press-releases/2025-06-25-gartner-identifies-three-trends-that-will-shape-the-future-of-customer-service?utm_source=chatgpt.com" target="_blank" rel="noopener noreferrer" className="link-basic">Read the article</a>
        </div>
      </div>

      <div className="statsGold-card">
        <div className="statsGold-number">87 % </div>
        <div className="statsGold-label">Enterprise teams expect AI to improve internal processes.</div>
        <div className="statsGold-text">
          <a href="https://www.pymnts.com/artificial-intelligence-2/2025/openai-ai-business-adoption-soars-as-employees-save-over-an-hour-daily/" target="_blank" rel="noopener noreferrer" className="link-basic">Read the article</a>
        </div>
      </div>

      <div className="statsGold-card">
        <div className="statsGold-number">240</div>
        <div className="statsGold-label">Hours/year which lawyers can save due to GenAI.</div>
        <div className="statsGold-text">
          <a href="https://legal.thomsonreuters.com/blog/how-ai-is-transforming-the-legal-profession/?utm_source=chatgpt.com/" target="_blank" rel="noopener noreferrer" className="link-basic">Read the article</a>
        </div>
      </div>
    </div>
  </div>
 </section> 
 <section className='components-library'>
  <div className='component-head'>
  <h2>Component Library Groups</h2>
  </div>

 <InfiniteCarousel slides={slides} />
</section>
<section className="featureSection">
  <h2>Next-Generation Architecture : Speed, Flexibility, and Zero Lock-in</h2>
  <div className="featureGrid">
   
    <div className="featureItem">
      <div className="featureIcon">
        <img src="/images/slice3.png" alt="Single Slice Utilities" />
      </div>
      <h3>
        Single Slice Utilities –
        <br />
        <span>Focused tools that solve a specific problem.</span>
      </h3>
    </div>

    <div className="featureItem">
      <div className="featureIcon dark">
        <img src="/images/reuse.png" alt="Reusable Library" />
      </div>
      <h3>
        Reusable Library –
        <br />
        <span>Shareable modules for teams or clients.</span>
      </h3>
    </div>

    <div className="featureItem">
      <div className="featureIcon">
        <img src="/images/rapid.png" alt="Rapid Deployment" />
      </div>
      <h3>
        Rapid Deployment –
        <br />
        <span>Enterprise rollout in 2–5 days.</span>
      </h3>
    </div>

    <div className="featureItem">
      <div className="featureIcon">
        <img src="/images/cost.png" alt="Zero Cost Activation" />
      </div>
      <h3>
        Zero Cost Activation –
        <br />
        <span>Start instantly with no upfront investment.</span>
      </h3>
    </div>

    <div className="featureItem">
      <div className="featureIcon dark">
        <img src="/images/meter.png" alt="Metered Consumption" />
      </div>
      <h3>
        Metered Consumption –
        <br />
        <span>Pay only for what you use.</span>
      </h3>
    </div>

    <div className="featureItem">
      <div className="featureIcon">
        <img src="/images/llm.png" alt="LLM Agnostic" />
      </div>
      <h3>
        LLM Agnostic –
        <br />
        <span>Compatible with any AI model, avoiding lock-in.</span>
      </h3>
    </div>

  </div>
</section>

  <div>
      {/* ...previous sections... */}

      <RemoteCarousel slides={remoteSlides} />

      {/* ...next sections... */}
    </div>

{/* CONTACT / HELP SECTION */}
<section id='contact'
  className="contactGold"
  style={{ backgroundImage: "url('/images/contact-bg.jpg')" }}
>
  <div className="contactGold-overlay" />

  <div className="contactGold-wrap">
    {/* gold corner lines */}
    <span className="contactGold-corner tl" />
    <span className="contactGold-corner br" />

    <h2 className="contactGold-title">HOW WE CAN HELP YOU?</h2>

    <form className="contactGold-form">
      <input
        type="text"
        placeholder="Enter your Name"
        required
      />

      <input
        type="email"
        placeholder="Enter your E-Mail"
        required
      />

      <textarea
        placeholder="Enter your Message"
        rows="4"
        required
      />

      <button type="submit">SUBMIT</button>
    </form>
  </div>
</section>
{/* FOOTER STRIP (4 columns) */}
<footer className="footerStrip">
  <div className="footerStrip-wrap">
    <div className="footerStrip-col">
      <div className="footerStrip-line" />
      <p>Blue Enterprises<br/>
        10 Anson Road, #05-01,<br/> Singapore 079903
      </p>
    </div>

    <div className="footerStrip-col">
      <div className="footerStrip-line" />
      <p><a href='https://www.linkedin.com/company/blue-enterprise-analytics-singapore'>LinkedIn</a></p>
    </div>
  </div>
</footer>
    </div>
  );
}
